(function() {
    // Function to initialize Flickity sliders that haven't been initialized yet
    function initProductSliders() {
      var sliders = document.querySelectorAll('.sr4-pr-media-slider.flickitysr4:not(.flickitysr4-enabled)');
      sliders.forEach(function(slider) {
        if (typeof sr4ThemeSP !== 'undefined' && sr4ThemeSP.Carousel) {
          slider.flickitysr4 = new sr4ThemeSP.Carousel(slider);
        }
      });
    }

    // Initialize on DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductSliders);
    } else {
      initProductSliders();
    }

    // Re-initialize after AJAX pagination loads new content
    // Listen for currency:update event which fires after AJAX content loads
    document.body.addEventListener('currency:update', function() {
      setTimeout(initProductSliders, 100);
    });

    // Also use MutationObserver to detect when new products are added
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              // Check if the added node contains product sliders
              var sliders = node.querySelectorAll ? node.querySelectorAll('.sr4-pr-media-slider.flickitysr4:not(.flickitysr4-enabled)') : [];
              if (sliders.length > 0) {
                setTimeout(initProductSliders, 100);
              }
              // Also check if the node itself is a product slider
              if (node.classList && node.classList.contains('sr4-pr-media-slider') && node.classList.contains('flickitysr4') && !node.classList.contains('flickitysr4-enabled')) {
                setTimeout(initProductSliders, 100);
              }
            }
          });
        }
      });
    });

    // Start observing the product grid container
    var productContainer = document.querySelector('[data-contentlm-replace], .sr4-products, [data-ntajax-container]');
    if (productContainer) {
      observer.observe(productContainer, { childList: true, subtree: true });
    } else {
      // Fallback: observe body if container not found immediately
      document.addEventListener('DOMContentLoaded', function() {
        var container = document.querySelector('[data-contentlm-replace], .sr4-products, [data-ntajax-container]');
        if (container) {
          observer.observe(container, { childList: true, subtree: true });
        }
      });
    }
  })();